let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Hr1I")).then(() => parcelRequire('9a8nx'));